var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatinggirl101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff715d;}.cls-2{fill:#fff;}.cls-3{fill:#f4e211;}.cls-4{fill:#bd5521;}.cls-5{fill:#ebc0ff;}.cls-6{clip-path:url(#clip-path);}.cls-7{clip-path:url(#clip-path-2);}.cls-14,.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}.cls-8{stroke-width:2px;}.cls-9{clip-path:url(#clip-path-3);}.cls-10{clip-path:url(#clip-path-4);}.cls-11{fill:#e1dacf;}.cls-12{fill:#2ca0ff;}.cls-13{clip-path:url(#clip-path-5);}.cls-14{stroke-width:3px;}.cls-15{clip-path:url(#clip-path-6);}.cls-16{clip-path:url(#clip-path-7);}.cls-17{clip-path:url(#clip-path-8);}.cls-18{clip-path:url(#clip-path-9);}.cls-19{clip-path:url(#clip-path-10);}.cls-20{clip-path:url(#clip-path-11);}.cls-21{fill:#f5f1e5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.74,311.42s-5.83-111.1-89.9-110.56c0,0-71.94-5.89-143.57,148.7-9.9,21.36-2.9,47,16.85,59.84,16.65,10.8,45.33,17.7,94.32,12.68l122.3-110.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329,392.7s-29.47-31.18-79,41.45c0,0-63.69,6.37-70.56-49.24,0,0,98.94-130.38,236.25-77.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240,540.26s-62.1-116.74-120-86.17a50.28,50.28,0,0,0-12.45,9.5c-16.74,17.23-80.68,90.74-72.92,201.33a90.29,90.29,0,0,0,8.24,32.34c13.87,29.28,51.39,66.2,145.74-24.77L240,540.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192,598.57S142.47,545.69,81.62,625.3c0,0-31.18,32.83-41.88,88.19,0,0,33.38,35.66,43.31,37.58s18.57-76.32,103.17-105.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1337.48,822.85c2.06,28.91-8.79,58.65-29.53,78.89-22.92,22.36-56.38,32.12-88.31,29.84s-62.36-15.73-88.44-34.3c-7.62-5.43-15.1-11.5-19.8-19.59s-6.17-18.62-1.55-26.77,16.29-12.19,24-6.87c-8.16-8.28-16.41-16.79-21.54-27.21s-6.73-23.26-1.35-33.56,19-16.44,29.38-11.18A34.24,34.24,0,0,1,1183,725.3c12.63,4.59,21.34,16,32.31,23.78a63.32,63.32,0,0,0,39.84,11.45c12.47-.7,23.92-5.21,35.36-9.82,7.31-3,8.45-2.82,14.15,2.74a112.73,112.73,0,0,1,10.46,11.7A107.79,107.79,0,0,1,1337.48,822.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1094.74,
    cy: 303.07,
    rx: 73.65,
    ry: 77.65,
    transform: "translate(589.33 1320.36) rotate(-79.06)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1151.57,
    cy: 450.09,
    r: 78.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1083.65,
    cy: 435.84,
    r: 18.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M754.6,278.65c-12.39,19.83-32.93,34.85-56,38.71-30.17,5.05-61-9.14-83.24-30.14s-37.43-48.22-52.28-75c-6-10.9-12.17-22-14.66-34.23s-.79-25.92,7.39-35.32,23.77-12.61,33.51-4.82c-7.09-17.37-9.81-39.26,2.67-53.25a30.88,30.88,0,0,1,49.74,5c2.08-12.86,6-28,18.36-32.22,8.69-2.95,18.53,1.24,24.81,7.93s9.78,15.46,13.13,24l29.86,76.19a96.61,96.61,0,0,1,22.34-28c9.06-7.79,21-14.12,32.6-11.39s19.67,14.13,20.83,25.9S800,175.56,792.89,185c-5.78,7.66-14.06,12.64-20.06,19.83-5.07,6.09-2.94,12.13-3,19.71C769.6,243.46,764.67,262.54,754.6,278.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1338.44,655.18,1292,778.37a34,34,0,0,1-44.56,19.5L1175,768.47a11.2,11.2,0,0,1-6.29-14.28L1222.43,609a11.21,11.21,0,0,1,14.71-6.51l95,38.3A11.22,11.22,0,0,1,1338.44,655.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1170.2,492c-7.07,5.71-17,4.26-21.34-1.51-4.76-6.27-2.76-17.29,6-22Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "floating girl 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shoe1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.74,311.42s-5.83-111.1-89.9-110.56c0,0-71.94-5.89-143.57,148.7-9.9,21.36-2.9,47,16.85,59.84,16.65,10.8,45.33,17.7,94.32,12.68l122.3-110.66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329,392.7s-29.47-31.18-79,41.45c0,0-63.69,6.37-70.56-49.24,0,0,98.94-130.38,236.25-77.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 284.85,
    cy: 375.3,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 256.86,
    cy: 343.73,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 289.75,
    cy: 325.8,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 335.72,
    cy: 312.73,
    r: 6.08
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433,231.41s-72.88,75.16-142.28-27.51C290.72,203.9,370.52,110.11,433,231.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.54,447.35s40.51-108.35-93.19-90.7C180.35,356.65,180.2,456.61,273.54,447.35Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_2",
    "data-name": "shoe 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240,540.26s-62.1-116.74-120-86.17a50.28,50.28,0,0,0-12.45,9.5c-16.74,17.23-80.68,90.74-72.92,201.33a90.29,90.29,0,0,0,8.24,32.34c13.87,29.28,51.39,66.2,145.74-24.77L240,540.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192,598.57S142.47,545.69,81.62,625.3c0,0-31.18,32.83-41.88,88.19,0,0,33.38,35.66,43.31,37.58s18.57-76.32,103.17-105.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 120.62,
    cy: 665.53,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 93.97,
    cy: 640.13,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 118.37,
    cy: 615.42,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 146.36,
    cy: 637.82,
    r: 6.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 148.75,
    cy: 602.38,
    r: 6.08
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.83,752.88s19.66-116.26-109.62-105C16.21,647.89.58,778,125.83,752.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M211.3,469.66s-42.45,90.62-152.67,24.56C58.63,494.22,116.07,387,211.3,469.66Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "leg_2",
    "data-name": "leg 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M637.31,567.63c-68.28-41-168.78-122.1-198.57-256.21,0,0-79.65-47.07-131.9,31.29,0,0-18.09,182.86,127.68,309.33,52,61.26,132.86,80.18,193,50.17a127.81,127.81,0,0,0,12.76-7.32C686.56,664.7,684.69,596.05,637.31,567.63Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M846.63,633.52S763.71,549.9,648,589.85c0,0-248.06,120.91-408.08-49.59,0,0-69.09,8.35-92.76,93.22,0,0,246.57,489.56,757.21,244.12h0a136.32,136.32,0,0,0-57.78-244.08"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1199.64,495.22S1408.92,559.55,1428.28,704c10.43,77.76-51.92,146.75-130.28,143-1,0-2-.1-3-.17l-137-26.49S1058,932,904.41,877.6c0,0-84.25-108-57.78-244.08,0,0,4.08-176.08,158.73-150.28,0,0,37.78,22.41,121.71,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1337.48,822.85c2.06,28.91-8.79,58.65-29.53,78.89-22.92,22.36-56.38,32.12-88.31,29.84s-62.36-15.73-88.44-34.3c-7.62-5.43-15.1-11.5-19.8-19.59s-6.17-18.62-1.55-26.77,16.29-12.19,24-6.87c-8.16-8.28-16.41-16.79-21.54-27.21s-6.73-23.26-1.35-33.56,19-16.44,29.38-11.18A34.24,34.24,0,0,1,1183,725.3c12.63,4.59,21.34,16,32.31,23.78a63.32,63.32,0,0,0,39.84,11.45c12.47-.7,23.92-5.21,35.36-9.82,7.31-3,8.45-2.82,14.15,2.74a112.73,112.73,0,0,1,10.46,11.7A107.79,107.79,0,0,1,1337.48,822.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1140.33,772.1c15.74,21.16,35.45,34,60.53,42.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1133.84,844.05c10.31,10.69,18,13.32,32.44,16.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1174.47,854.77a11.37,11.37,0,0,0-7,16.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1208.06,808.25a17,17,0,0,0-8.3,17.21"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "collar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1193.41,516.23s26.45,54.57-28.16,69.51a80.92,80.92,0,0,1-43.09-.32c-16.14-4.5-40.22-13.34-56.57-28.9a42.67,42.67,0,0,1,6.47-66.82l9-5.79c2.55,4.95,16,29.86,46.65,39.75,33.6,10.86,61.4-4.91,65.66-7.43"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1094.74,
    cy: 303.07,
    rx: 73.65,
    ry: 77.65,
    transform: "translate(589.33 1320.36) rotate(-79.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1057.63,258.31c4.29-4.74,10.41-7.51,16.66-8.85s12.7-1.33,19.09-1.29c1.47,0,3.29.24,3.83,1.61.47,1.19-.36,2.5-1.34,3.33a8.94,8.94,0,0,1-6.81,2,13.66,13.66,0,0,0-3.47-.33c-1.15.18-2.31,1.18-2.1,2.33.28,1.51,2.32,1.72,3.85,1.62a58.41,58.41,0,0,1,13.53.77c2.23.39,4.69,1.1,5.8,3.07,1.21,2.17.12,5.11-1.92,6.54a9.69,9.69,0,0,1-7.19,1.15c-2.45-.42-4.78-1.38-7.18-2a12.46,12.46,0,0,0-7.35-.14c-1.25.44-2.55,1.73-1.93,2.9s2.21,1,3.05,1.85a2.21,2.21,0,0,1,.33,2.33,4.59,4.59,0,0,1-1.61,1.86,7.32,7.32,0,0,1-7.34,1c-2.34-1.13-3.63-4.33-2.25-6.53.58-.92,1.55-1.65,1.75-2.72.31-1.73-1.78-3.12-3.51-2.82s-3.09,1.62-4.32,2.87c-4.66,4.71-10,9.49-16.65,10-2.33.18-5.17-.59-5.78-2.85a4.1,4.1,0,0,1,1.46-3.95,10.56,10.56,0,0,1,4-1.91,5.78,5.78,0,0,0,2.75-1.4,1.85,1.85,0,0,0-.16-2.72c-.78-.45-1.75,0-2.58.35s-2,.54-2.48-.19a2.1,2.1,0,0,1,.09-2c2.34-5.41,7.4-9.26,12.88-11.43s11.41-2.87,17.26-3.55"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1124.55,
    cy: 375.27,
    rx: 26.82,
    ry: 28.66,
    transform: "translate(542.6 1408.11) rotate(-79.06)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1151.57,
    cy: 450.09,
    r: 78.27
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1219.91,416.52a13.88,13.88,0,0,1-13.42,5.39c-8.06-1.46-12.9-9.47-17.26-16.41s-10.87-14.33-19-13.36c-7.24.86-12,8.16-13.83,15.21s-1.84,14.61-4.75,21.29-10.35,12.39-17.19,9.87c-4.84-1.78-7.53-6.92-9.1-11.83s-2.55-10.22-5.78-14.24-9.78-6-13.55-2.49c-4.69,4.4-1.34,12.81-4.73,18.28-2.86,4.63-9.92,5.22-14.46,2.21s-6.79-8.55-7.42-14c-1.16-10.08,2.6-20.36,8.95-28.28s15.12-13.62,24.45-17.63a91.14,91.14,0,0,1,61-3.69C1188.87,371.29,1235.77,394.65,1219.91,416.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1182.11,461.43s1.69,19.45-7.38,18.83"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1139.97,
    cy: 463.73,
    r: 4.85
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "ear"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1083.65,
    cy: 435.84,
    r: 18.53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1093.33,433.55a12.7,12.7,0,0,0-20.11-3.89"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "right_hand",
    "data-name": "right hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M994.68,477.54C934.09,448.7,806,376.9,754.34,257.13L647.26,300.68s-.61,267.65,252.7,355.1c36.76,12.69,77.8,5.49,107.2-19.95A106.22,106.22,0,0,0,1034,600.5c.35-.76.7-1.52,1-2.27C1055.22,552,1040.21,499.22,994.68,477.54Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "fingers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M754.6,278.65c-12.39,19.83-32.93,34.85-56,38.71-30.17,5.05-61-9.14-83.24-30.14s-37.43-48.22-52.28-75c-6-10.9-12.17-22-14.66-34.23s-.79-25.92,7.39-35.32,23.77-12.61,33.51-4.82c-7.09-17.37-9.81-39.26,2.67-53.25a30.88,30.88,0,0,1,49.74,5c2.08-12.86,6-28,18.36-32.22,8.69-2.95,18.53,1.24,24.81,7.93s9.78,15.46,13.13,24l29.86,76.19a96.61,96.61,0,0,1,22.34-28c9.06-7.79,21-14.12,32.6-11.39s19.67,14.13,20.83,25.9S800,175.56,792.89,185c-5.78,7.66-14.06,12.64-20.06,19.83-5.07,6.09-2.94,12.13-3,19.71C769.6,243.46,764.67,262.54,754.6,278.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M641.74,89.66c-1.62,28.21,5.36,53.69,20,77.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M589.33,137.88c8.93,19,17.75,31.24,32.76,45.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M629.86,180.4A20.45,20.45,0,0,0,617,193.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M672.24,166.67a21.16,21.16,0,0,0-17.77,9.64"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1338.44,655.18,1292,778.37a34,34,0,0,1-44.56,19.5L1175,768.47a11.2,11.2,0,0,1-6.29-14.28L1222.43,609a11.21,11.21,0,0,1,14.71-6.51l95,38.3A11.22,11.22,0,0,1,1338.44,655.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1324,653.79l-81-33.55a8.17,8.17,0,0,0-10.8,4.72l-55.87,151.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1303.22,
    cy: 674.31,
    r: 6.87
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M648,589.85s-100.27,50.45-238.83,38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M846.63,633.52S909.1,676.63,986,650.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M249.18,567s-65.31,11-72.29,76.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M423.22,333.68s-53.94-25.77-98.94,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M782.08,760.75s-27.78,92.69-130.25,79.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1146.7,358.79s-34.32-11.91-50.64,18.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M761.55,305.07s-40.94,41.46-93.78,28.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1137.1,588.59s-113.6-21-77.82-86.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1184.76,529s10.93,9.3,1.45,25.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1147.27,536s16,19.92-2.93,41.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1116,530s-.63,25.3-25.41,33.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1085.45,508.17s-2.82,23-24.65,18.74"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_1",
    "data-name": "eyebrow 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1205.45,
    cy: 446.18,
    rx: 5.34,
    ry: 9.4,
    transform: "translate(297.88 1356.41) rotate(-65.4)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_2",
    "data-name": "eyebrow 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1158.59,
    cy: 437.21,
    rx: 10.12,
    ry: 5.84,
    transform: "translate(-37.02 114.71) rotate(-5.58)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "eye1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1199.78,
    cy: 463.49,
    r: 4
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "eye_2",
    "data-name": "eye 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1158.77,
    cy: 455.56,
    r: 3.99
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1170.2,492c-7.07,5.71-17,4.26-21.34-1.51-4.76-6.27-2.76-17.29,6-22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1155.48,496.25s3.83-12-10.31-15.54C1145.17,480.71,1140.23,495.4,1155.48,496.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1168.63 487.04 1162.77 489.95 1152.99 475.3 1159.19 471.98 1168.63 487.04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatinggirl101);
export default __webpack_public_path__ + "static/media/floating girl 1-01.bba50f20053d5e61691944288c17395a.svg";
export { ForwardRef as ReactComponent };